import { render, staticRenderFns } from "./oauth.vue?vue&type=template&id=21217224&scoped=true"
import script from "./oauth.js?vue&type=script&lang=js&external"
export * from "./oauth.js?vue&type=script&lang=js&external"
import style0 from "./oauth.vue?vue&type=style&index=0&id=21217224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21217224",
  null
  
)

export default component.exports